export default __webpack_public_path__ + "static/media/tick-rounded.40db8f41.svg";